/**
 * Fuente única de verdad para autores del blog.
 * - Cada autor tiene un slug que se usa en URLs `/autor/:slug`
 * - `categories` controla a qué categorías se asigna automáticamente
 * - El autor con slug `default` se aplica a cualquier categoría que no matchee otro
 */

export const AUTHORS = {
  'nelson-gonzalez': {
    slug: 'nelson-gonzalez',
    name: 'Nelson González',
    role: 'Fundador & Estratega Digital',
    bio: 'Fundador de SinAdicciones.org. Más de 15 años de experiencia en marketing digital, pionero en Chile en estrategias de Inbound Marketing.',
    image: '/images/team/nelson_gonzalez.jpg',
    email: 'contacto@sinadicciones.cl',
    linkedin: 'https://www.linkedin.com/in/nelsongonzalezr/',
    twitter: null,
    categories: ['Marketing', 'marketing'],
    expertise: [
      'Inbound Marketing',
      'Marketing Digital para Salud',
      'Estrategia de Captación B2B',
      'SEO y Posicionamiento Web',
    ],
  },
  'ricardo-manzur': {
    slug: 'ricardo-manzur',
    name: 'Ricardo Manzur Carrasco',
    role: 'Editor & Periodista Especializado en Adicciones',
    bio: 'Periodista con más de 20 años de carrera, ex editor nacional. Certificado por OPS/OMS y SENDA en neurobiología del consumo y política de drogas. Investiga y escribe sobre rehabilitación, salud mental y políticas públicas en Chile.',
    image: '/images/team/ricardo_manzur.png',
    email: 'contacto@sinadicciones.cl',
    linkedin: 'https://www.linkedin.com/in/ricardo-manzur/',
    twitter: null,
    isDefault: true,
    categories: ['*'],
    expertise: [
      'Adicciones y Salud Mental',
      'Periodismo de Investigación',
      'Política de Drogas',
      'Neurobiología del Consumo',
    ],
  },
};

const SITE_URL = 'https://sinadicciones.org';

/**
 * Devuelve el autor que corresponde a una categoría.
 * Si no hay match exacto, devuelve el autor con isDefault=true.
 */
export function getAuthorByCategory(category) {
  if (!category) return AUTHORS['ricardo-manzur'];
  const list = Object.values(AUTHORS);
  // Match exacto por nombre de categoría
  const match = list.find((a) =>
    (a.categories || []).some(
      (c) => c.toLowerCase() === String(category).toLowerCase(),
    ),
  );
  if (match) return match;
  // Fallback al default
  return list.find((a) => a.isDefault) || AUTHORS['ricardo-manzur'];
}

/**
 * Devuelve el autor por su nombre completo (case-insensitive).
 * Útil cuando el artículo ya tiene un `author_name` asignado.
 */
export function getAuthorByName(name) {
  if (!name) return null;
  const list = Object.values(AUTHORS);
  return (
    list.find((a) => a.name.toLowerCase() === name.toLowerCase()) ||
    list.find((a) => name.toLowerCase().includes(a.name.split(' ')[0].toLowerCase())) ||
    null
  );
}

/**
 * Devuelve el autor por slug.
 */
export function getAuthorBySlug(slug) {
  return AUTHORS[slug] || null;
}

/**
 * Construye el objeto Schema.org Person para un autor.
 * Esto es lo que va dentro del JSON-LD del artículo y de la página de autor.
 */
export function buildAuthorPersonSchema(author) {
  if (!author) return null;
  const sameAs = [];
  if (author.linkedin) sameAs.push(author.linkedin);
  if (author.twitter) sameAs.push(author.twitter);
  return {
    '@type': 'Person',
    name: author.name,
    url: `${SITE_URL}/autor/${author.slug}`,
    image: author.image ? `${SITE_URL}${author.image}` : undefined,
    jobTitle: author.role,
    description: author.bio,
    sameAs: sameAs.length > 0 ? sameAs : undefined,
    knowsAbout: author.expertise,
    worksFor: {
      '@type': 'Organization',
      name: 'SinAdicciones.org',
      url: SITE_URL,
    },
  };
}

/**
 * Lista de categorías canónicas que se muestran en el editor admin.
 * Si necesitas agregar una nueva, hazlo aquí.
 */
export const BLOG_CATEGORIES = [
  'general',
  'Marketing',
  'Guías',
  'Adicciones',
  'Adicciones Conductuales',
  'Sustancias',
  'Centros Rehabilitación',
  'Tratamiento',
  'Prevención Recaída',
  'Recuperación',
  'Familia',
  'Salud Mental',
  'Educación',
];

export const SITE_URL_BASE = SITE_URL;
